import { z } from 'zod';
export const orgSettingsSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  address: z.string().optional(),
  gstin: z.string().optional(),
});
export type OrgSettingsInput = z.infer<typeof orgSettingsSchema>;
